import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./components/Login";
import Register from "./components/Register";
import Consent from "./components/Consent";
import Home from "./components/Home";
import RegisterPhone from "./components/RegisterPhone";
import Scan from "./components/Scan";
import VerifyScan from "./components/VerifyScan";
import Profile from "./components/Profile";
import LogPanel from "./components/LogPanel";
import deviceDataFun from "./utils/DeviceData.js";

// import Profile from "./components/Profile";
import { LogProvider } from "./context/LogContext";


import "./styles.css";

const ProtectedRoute = ({ children }) => {
  const user = localStorage.getItem("userData");
  return user ? children : <Navigate to="/" />;
};

// 1. Consent Guard: Ensures that Consent has been accepted
const ConsentGuard = ({ children }) => {
  const consent = sessionStorage.getItem("consentAccepted");
  if (!consent) return <Navigate to="/consent" />;
  return children;
};

// 2. Scan Guard: Ensures that /scan is accessed only through a valid flow
const ScanGuard = ({ children }) => {
  const consent = sessionStorage.getItem("consentAccepted");
  const canScan = sessionStorage.getItem("canAccessScan");

  if (!consent) return <Navigate to="/consent" />;
  if (!canScan) return <Navigate to="/" />;
  return children;
};


const App = () => {
  const deviceData = deviceDataFun();

  if (deviceData.deviceName === "Mobile") {
    return (
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh", 
        backgroundColor: "#1a1a2e",
        color: "#fff",
        textAlign: "center",
        padding: "20px",
        fontFamily: "sans-serif"
      }}>
        <h1 style={{ color: "#e94560", marginBottom: "20px" }}>Mobile Browser Not Supported</h1>
        <p style={{ fontSize: "18px", marginBottom: "30px", maxWidth: "400px" }}>
          For the best experience on mobile, please use our official Android application.
        </p>
        <a 
          href="https://backendapi.byosync.in/apk/ByoSync.apk" 
          style={{ 
            padding: "12px 24px", 
            backgroundColor: "#007bff", 
            color: "white", 
            textDecoration: "none", 
            borderRadius: "8px",
            fontWeight: "bold",
            boxShadow: "0 4px 15px rgba(0,123,255,0.3)"
          }}
        >
          Download APK
        </a>
      </div>
    )
  }
  return (
    <LogProvider>
      <BrowserRouter>
        <div className="main-layout">
          <div className="left-section">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/consent" element={<Consent />} />

              {/* Protected routes that require Consent */}
              <Route path="/verify-phone" element={<ConsentGuard><RegisterPhone /></ConsentGuard>} />
              <Route path="/register" element={<ConsentGuard><Register /></ConsentGuard>} />
              <Route path="/verify-scan" element={<ConsentGuard><VerifyScan /></ConsentGuard>} />

              {/* /scan only opens if redirected from /register or Home */}
              <Route path="/scan" element={<ScanGuard><Scan /></ScanGuard>} />

              <Route path="/login" element={<Login />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </div>
          <div className="right-section">
            <LogPanel />
          </div>
        </div>
      </BrowserRouter>
    </LogProvider>
  );
};

export default App;
